module.exports = __webpack_public_path__ + "static/media/icon_sync.493ffcde.svg";